<template>
  <div>
    <div class="invoiceList">
      <v-layout row wrap>
        <v-flex xs12>
          <v-toolbar class="primary white--text" style="margin-top: 10px">
            <v-flex xs12 md1 sm1>
              <h3 class="title font-weight-light">{{isSale ?'Sales Register' : 'Purchase Register'}}</h3>
            </v-flex>      
            <template>
            <v-flex xs12 md2 sm2>
              <v-select
                class="select-firm"
                dense
                :items="firmsByBrand"
                label="Select Firm"
                v-model="selectedFirm"
                clearable
              ></v-select>
            </v-flex>
            <v-spacer/>
            <v-flex xs12 sm2 md2>
              <v-select
                class="select-firm"
                dense
                :items="branchsByBrand"
                label="Select branch"
                v-model="selectedBranch"
                clearable
              ></v-select>
            </v-flex>
            <v-spacer/>
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerFrom"
                  :nudge-right="40"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="white-datepicker"
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateFrom"
                    label="From Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateFrom"
                    @input="datepickerFrom = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 sm2 md2>
                <v-menu
                  :close-on-content-click="false"
                  v-model="datepickerTo"
                  :nudge-right="40"
                  lazy
                  class="white-datepicker"
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="dateTo"
                    label="To Date"
                    prepend-icon="event"
                    readonly
                  ></v-text-field>
                  <v-date-picker
                    v-model="dateTo"
                    @input="datepickerTo = false"
                  ></v-date-picker>
                </v-menu>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 md1 sm1>
                <v-switch
                  v-model="isStatementView"
                  color="white"
                  class="white-switch subheading font-weight-bold"
                  :label="`${isStatementView ? 'View' : 'View'}`"
                ></v-switch>
              </v-flex>
              <v-spacer/>
              <v-flex xs12 md1 sm1>
                <router-link to="/Dashboard">
                  <v-btn icon dark style="float: right">
                    <v-icon>close</v-icon>
                  </v-btn>
                </router-link>
                <v-btn 
                  icon dark
                  @click="print()"
                  style="float: left"
                >
                <v-icon class="primary white--text">
                  picture_as_pdf
                </v-icon>                  
                </v-btn>
              </v-flex>
            </template>
          </v-toolbar>
        </v-flex>
      </v-layout>
      <!-- <v-data-table :items="invoicesByBrand" class="elevation" :headers="headers"> -->
      <v-data-table
        :items="isStatementView ? statmentData : normalData"
        class="elevation transaction-table"
        :pagination.sync="pagination"
        :headers="isStatementView ? headers : invoiceHeader"
      >
        <template slot="items" slot-scope="props">
          <statement-view
            v-if="isStatementView"
            :item="props.item"
            :firms="firms"
            :buyers="buyers"
            :sellers="sellers"
          />
          <normal-view
            v-else
            :item="props.item"
            :firms="firms"
            :buyers="buyers"
            :sellers="sellers"
            @openItems="openItems"
          />
        </template>
        <template slot="no-data">No rows to Show</template>
      </v-data-table>
    </div>
     <v-dialog
              v-model="dialog11"
              persistent
              width="1000"
              v-if="selectedInvoice && selectedInvoice['.key']"
            >
              <v-card>
                <v-card-title class="title grey lighten-2">
                  &nbsp; <b>{{buyerById(selectedInvoice.buyerId).name}} </b>
                  <v-spacer></v-spacer>
                  <v-btn icon dark class="white--text" @click="dialog11 = false">
                    <v-icon dark>clear</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-layout row wrap>
                    <v-flex xs12 md4>
                      <!-- <b>key :-</b>
                      {{selectedInvoice['.key']}}
                      <br /> -->
                      <b>Name :-</b>
                      <!-- {{selectedInvoice.customer ? selectedInvoice.customer.name : ''}} -->
                        {{buyerById(selectedInvoice.buyerId).name}}
                      <br />
                      <b>Firm :-</b>
                      {{getFirmName(selectedInvoice.firm)}}
                      <br />
                      <b>invoiceId :-</b>
                      {{selectedInvoice['invoiceId']}}
                      <br />
                      <b>Duration (in Days) :-</b>
                      {{selectedInvoice['duration']}}
                      <br />
                      <b>Payment Type :-</b>
                      {{selectedInvoice['paymentType']}}
                      <br />
                      <b>Status :-</b>
                      {{selectedInvoice['status']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <b class="success--text font-weight-bold">Total Amount:</b>
                       {{selectedInvoice['totalAmount']}}
                      <br />
                      <b class="primary--text font-weight-bold">Basic Amount:</b>
                       {{selectedInvoice['totalAmount'] - getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="primary--text font-weight-bold">Total GST: </b>
                       {{getGSTtotal(selectedInvoice)}}
                      <br />
                      <b class="green--text font-weight-bold">Paid Amount:</b>
                       {{selectedInvoice['paidAmount']}}
                      <br />
                      <b class="red--text font-weight-bold">Due Amount:</b>
                       {{selectedInvoice['remainingAmount']}}
                      <br />
                      <b>Discount:</b>
                       {{selectedInvoice['discountAmount']}}
                      <br />
                    </v-flex>
                    <v-flex xs12 md4>
                      <!-- <b>Transaction Type :-</b>
                      {{selectedInvoice['transactionType']}}
                      <br /> -->
                      <b>GST Type: </b>
                      {{selectedInvoice['gstType']}}
                      <br />
                      <b>GST (3%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_3']}}
                      <br />
                      <b>GST (5%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_5']}}
                      <br />
                      <b>GST (12%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_12']}}
                      <br />
                      <b>GST (18%):</b>
                       {{selectedInvoice['GST_Percentage_total']['GST_18']}}
                      <br />
                      <b>GST (28%): </b>
                       {{selectedInvoice['GST_Percentage_total']['GST_28']}}
                      <br />
                    </v-flex>
                  </v-layout>
                  <v-data-table
                    :headers="invoiceProductListHeader"
                    :items="selectedInvoice.items"
                    class="elevation-1 dashboardHead"
                  >
                    <template slot="items" slot-scope="props">
                      <td>
                        <b>{{ props.item['productName']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['HSN_code']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.taxableGST_rate}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['productUnit']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item['quantity']}}</b>
                      </td>
                      <td>
                        <b>{{ props.item.rate}}</b>
                      </td>
                       <td v-if="businessType == 'Jwellery'">
                        <b>{{ Number.parseFloat(props.item.netWeight).toFixed(3)}}</b>
                      </td>
                    </template>
                    <template slot="no-data">No Items</template>
                  </v-data-table>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="primary" text @click="dialog11 = false">Close</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];
import { convertToPDFReport } from "../../utils/pdf-reports/dashboard-reports";
import { getGSTPercentageTotal } from "../../utils/";
import StatementView from "./StatementView";
import NormalView from "./normalView"

export default {
  components: {
    StatementView,
    NormalView,
  },
  data: () => ({
    headers: [
      { text: "Date", value: "date", sortable: true },
      { text: "Customer Name", value: "expense", sortable: true },
      { text: "Debit", value: "category", sortable: true },
      { text: "Credit", value: "underHead", sortable: false },
      { text: "Voucher type", value: "totalAmount", sortable: false },
      { text: "Payment type", value: "totalAmount", sortable: false },
      { text: "Status", value: "status", sortable: true },
      { text: "Remark", sortable: false },
    ],
    invoiceHeader: [
        // { text: "Invoice - Key", value: "Name" },
        { text: "Date", value: "date", sortable: true },
        { text: "Action", value: "action" },
        { text: "Buyer Name", value: "Father Name" },
        { text: "Invoice No", value: "invoiceId", sortable: true  },
        { text: "Total Amount", value: "totalCurrentAmount" },
        { text: "Basic Amount", value: "basic amount" },
        { text: "GST", value: "GST" },
        { text: "Extra Charges", value: "Extra Charges" },
        { text: "Discount", value: "discount" },
        { text: "Paid Amount", value: "Tehsil" },
        { text: "Due Amount", value: "District" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Status", value: "Mobile" },
        // { text: "Transaction Type", sortable: true, value: "paymentType" },
        { text: "GST Type", sortable: true, value: "gstType" },
        { text: "IGST Value", sortable: true, value: "gstType" },
        { text: "SGST Value", sortable: true, value: "gstType" },
        { text: "CGST Value", sortable: true, value: "gstType" },
        { text: "GST (3%)", sortable: true, value: "gstType" },
        { text: "GST (5%)", sortable: true, value: "gstType" },
        { text: "GST (12%)", sortable: true, value: "gstType" },
        { text: "GST (18%)", sortable: true, value: "gstType" },
        { text: "GST (28%)", sortable: true, value: "gstType" },
        { text: "Duration (in Days)", value: "abs" },
        { text: "Admin email", sortable: true, value: "gstType" },
        { text: "Firm Name", value: "firmName" },
        { text: "Branch Name", value: "branch" },
        { text: "Voucher type", value: "totalAmount", sortable: false },
      ],
      invoiceProductListHeader: [
        { text: "Name", value: "Name", class: "font-weight-bold primary--text" },
        { text: "HSN code", value: "HSN", class: "font-weight-bold primary--text" },
        { text: "Taxable rate", value: "Taxable", class: "font-weight-bold primary--text" },
        { text: "Unit", value: "Unit", class: "font-weight-bold primary--text" },
        { text: "Quantity", value: "quantity", class: "font-weight-bold primary--text" },
        { text: "Rate", value: "rate", class: "font-weight-bold primary--text" }
      ],
    pagination: {
      rowsPerPage: 10, // -1 for All",
    },
    businessType : null,
    isStatementView: false,
    statmentData:[],
    normalData:[],
    isSale : null,
    dateFrom: null,
    dateTo: null,
    datepickerFrom: false,
    selectedFirm : null,
    selectedBranch : null,
    datepickerTo: false,
    dialog11 : false,
    selectedInvoice : null,
  }),
  created() {
    this.$bindAsArray("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("branchs", this.$root.$firebaseRefs.branch.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("sellers", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("buyers", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand));
    if(this.$route.params.month && this.$route.params.date) {
      let date = parseInt(this.$route.params.date);
      let dateF = 1;
      let dateT = 0;
      if(date > 0) {
        dateF = date;
        dateT = date
    }
      let selectedMonth = Number.parseInt(this.$route.params.month);
      let dateFrom = new Date(this.finYear.start);
      let dateTo = new Date(this.finYear.end);
      let fullYear = dateFrom.getFullYear()
      if(selectedMonth < 3) {
        fullYear = dateTo.getFullYear()
      }
      this.dateFrom = this.formatDate(new Date(fullYear, selectedMonth, dateF).getTime());
      this.dateTo = this.formatDate(new Date(fullYear, (dateT == 0 ? selectedMonth + 1 : selectedMonth), dateT).getTime());
    } else if(this.finYear) {
        this.dateFrom = this.formatDate(this.finYear.start);
        this.dateTo = this.formatDate(this.finYear.end);
    }
    if(window.location.pathname.split('/')[1] =='sale-register') {
      this.isSale = true;
    } else {
      this.isSale = false
    }
    this.invoicesByBrand();
    this.invoicesByBrandNormal();
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","brandFinYear"]),
    firmsByBrand() {
      return this.firms
      .filter((item) => item["brand"] === this.selectedBrand)
      .map(item => {
          if (item.defaultFirm) {
            this.selectedFirm = item['.key'];
          }
          return {
            text: item["name"],
            value: item[".key"]
          };
      });;
    },
    branchsByBrand() {
      return this.branchs
        .filter((item) => {
          return (
            item["brand"] === this.selectedBrand &&
            item["firm"] === this.selectedFirm 
          );
        })
        .map((item) => {
          return {
            text: item["branchName"],
            value: item[".key"],
          };
        });
    },
  },
  watch:{
     "selectedFirm": {
      handler(newVal, oldVal) {
        this.setBussinessType();
        console.log(newVal)
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      },
      deep: true
    },
    "selectedBranch": {
      handler(newVal, oldVal) {
        console.log(newVal)
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
      },
      deep: true
    },
    "dateTo" : {
       handler(newVal, oldVal) {
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
       }
    },
    "dateFrom": {
        handler(newVal, oldVal) {
        this.invoicesByBrand();
        this.invoicesByBrandNormal();
       }
    }
  },
  methods: {
    invoicesByBrand() {
        let toDate = this.dateTo ?  new Date(this.dateTo).setUTCHours(23,59,59,999) : null;
        let fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0,0,0,0) : null;
        let invoiceHistory = this.invoices.filter(
          (item) =>
            item["brand"] === this.selectedBrand &&
            (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
            (this.selectedBranch ? item["branch"] === this.selectedBranch : true) &&
            (this.isSale ? item.isBuyer == true : item.isBuyer == false) &&
            (item.deleted != true) &&
            (!item.isCarryForwarded) &&
            (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
        );
        invoiceHistory.map((inv,index)=>{
          if(inv["items"] && inv["items"].length) 
          invoiceHistory[index]['GST_Percentage_total'] = getGSTPercentageTotal(inv["items"]);
          invoiceHistory[index]['voucherType'] = this.getVocherType(inv);
        })
        this.statmentData = invoiceHistory;
    },
    invoicesByBrandNormal() {
      let toDate = this.dateTo ?  new Date(this.dateTo).setUTCHours(23,59,59,999) : null;
      let fromDate = this.dateFrom ? new Date(this.dateFrom).setUTCHours(0,0,0,0) : null;
      let total = {
      name:'total',
      key:'total',
      totalAmount : 0,
      basicAmount : 0,
      gstTotal : 0,
      GST_3 : 0,
      GST_5 : 0,
      GST_12 : 0,
      GST_18 : 0,
      GST_28 : 0,
      totalExtraCharges : 0,
      roundOffAmount : 0,
      discountAmount : 0,
      paidAmount : 0,
      remainingAmount : 0
      };
      let invoiceHistory = this.invoices.filter(
        (item) =>
          item["brand"] === this.selectedBrand &&
          (this.selectedFirm ? item["firm"] === this.selectedFirm : true) &&
          (this.selectedBranch ? item["branch"] === this.selectedBranch : true) &&
          (this.isSale ? item.isBuyer == true : item.isBuyer == false) &&
          (item.deleted != true) &&
          (!item.isCarryForwarded) &&
          (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
      );
      invoiceHistory.map((inv,index)=>{
        if(inv["items"] && inv["items"].length) 
        invoiceHistory[index]['GST_Percentage_total'] = getGSTPercentageTotal(inv["items"]);
        let gst = this.getGSTtotal(inv);
        total.paidAmount += parseFloat(inv.paidAmount);
        total.remainingAmount += parseFloat(inv.remainingAmount);
        total.totalAmount += parseFloat(inv.totalAmount);
        // total.basicAmount += parseFloat(inv.totalAmount) - gst;
        total.basicAmount += (((parseFloat(inv.totalAmount) - (inv.totalExtraCharges || 0 ) - (inv.roundOffAmount || 0 )) - gst) || 0)
        total.discountAmount += parseFloat(inv.discountAmount);
        total.totalExtraCharges += parseFloat(inv.totalExtraCharges);
        total.roundOffAmount += parseFloat(inv.roundOffAmount);
        total.gstTotal += gst;
        total.GST_3 += parseFloat(inv.GST_Percentage_total.GST_3);
        total.GST_5 += parseFloat(inv.GST_Percentage_total.GST_5);
        total.GST_12 += parseFloat(inv.GST_Percentage_total.GST_12);
        total.GST_18 += parseFloat(inv.GST_Percentage_total.GST_18);
        total.GST_28 += parseFloat(inv.GST_Percentage_total.GST_28);
      })
      invoiceHistory.push(total)
      this.normalData = invoiceHistory;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    buyerById(id) {
      if (this.buyers[id]) {
        return this.buyers[id];
      } else if (this.sellers[id]) {
        return this.sellers[id];
      }
    },
    openItems(inv){
      this.selectedInvoice = JSON.parse(JSON.stringify(inv));
      let total = {
        productName : "Total",
        HSN_code : "",
        taxableGST_rate : "",
        productUnit : "",
        quantity : 0,
        rate : "",
        netWeight : 0
      }
      this.selectedInvoice.items.map((item)=>{
        total.quantity += parseInt(item.quantity)
        // total.rate += Number.parseFloat(item.rate)
        total.netWeight += Number.parseFloat(item.netWeight)
      })
      total.netWeight = Number.parseFloat(total.netWeight).toFixed(3)
      this.selectedInvoice.items.push(total)
      this.dialog11= true;
    },
    setBussinessType(){
      this.businessType = this.firms.find((item) => item[".key"] == this.selectedFirm).businessType;
      if(this.businessType == 'Jwellery' && this.invoiceProductListHeader[this.invoiceProductListHeader.length -1 ].text !="Net Weight") {
        this.invoiceProductListHeader.push({ text: "Net Weight", value: "weight", class: "font-weight-bold primary--text" })
      } 

      if(this.businessType != 'Jwellery' && this.invoiceProductListHeader[this.invoiceProductListHeader.length -1 ].text =="Net Weight") {
        this.invoiceProductListHeader.pop();
      }
    },
    formatDate(date) {
      var d = new Date(date),
        month = "" + (d.getMonth() + 1),
        day = "" + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map((item) => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return Number.parseFloat(GSTTotal);
    },
    getFirmName(id) {
      let firm = this.firms.filter((item) => item[".key"] == id)[0];
      if (firm) {
        return firm["name"];
      }
    },
    print() {
      if(!this.isStatementView) {
        this.isSale ? this.printSaleReport() : this.printPurchaseReport();
      } else {

      }
    },
    getVocherType(invoice) {
            if (invoice.return) {
                if (invoice.isBuyer) {
                return "Credit Note";
                } else {
                return "Debit Note";
                }
            }
            // if (invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Sale";
            // } 
            // else if (invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Receipt";
            // }
            // else if (invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Receipt";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
            //     return "Purchase";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Credit") {
            //     return "Payment";
            // }
            // else if (!invoice.isBuyer && invoice.transactionType === "Partial Paid") {
            //     return "Payment";
            // }
            if (invoice.isBuyer) {
                return "Sale";
            } else {
                return "Purchase";
            }
    },
    printPurchaseReport(){
      let purchaseInvoice = JSON.parse(JSON.stringify(this.normalData));
      purchaseInvoice = purchaseInvoice.filter((item => item['name']!='total'));
      purchaseInvoice.map((item,index)=>{
        purchaseInvoice[index]["firmName"] = this.getFirmName(item.firm);
        purchaseInvoice[index]["buyerName"] = this.buyerById(item.buyerId).name;
        purchaseInvoice[index]["GST_TOTAL"] = this.getGSTtotal(item);
        purchaseInvoice[index]["BASIC_AMOUNT"] = (item.totalAmount - purchaseInvoice[index]["GST_TOTAL"] || 0);
        purchaseInvoice[index]["IGST"] = (item.gstType == 'IGST' ? purchaseInvoice[index]["GST_TOTAL"] : 0)
        purchaseInvoice[index]["CGST"] = (item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"]/2 : 0)
        purchaseInvoice[index]["SGST"] = (item.gstType == 'SGST|CGST' ? purchaseInvoice[index]["GST_TOTAL"]/2 : 0)
        purchaseInvoice[index]["GST_3"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '')
        purchaseInvoice[index]["GST_5"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '')
        purchaseInvoice[index]["GST_12"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '')
        purchaseInvoice[index]["GST_18"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '')
        purchaseInvoice[index]["GST_28"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '')
      })
      let totalRow = document.querySelectorAll(".totalRow .totalField")
      purchaseInvoice.push({
         firmName : 'Total',
        buyerName : '',
        GST_TOTAL : totalRow[2].innerText.replaceAll(",",""),
        BASIC_AMOUNT : totalRow[1].innerText.replaceAll(",",""),
        discountAmount : totalRow[4].innerText.replaceAll(",",""),
        IGST : 0,
        CGST : 0,
        SGST : 0,
        GST_3 :  totalRow[7].innerText.replaceAll(",",""),
        GST_5 :  totalRow[8].innerText.replaceAll(",",""),
        GST_12:  totalRow[9].innerText.replaceAll(",",""),
        GST_18:  totalRow[10].innerText.replaceAll(",",""),
        GST_28:  totalRow[11].innerText.replaceAll(",",""),
        totalAmount : totalRow[0].innerText.replaceAll(",",""),

      })
      let doc = convertToPDFReport({
        type:'Purchase Register',
        invoiceData:purchaseInvoice,
        firm:this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate : this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
        toDate :  this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null,
      });
      pdfMake.createPdf(doc).download('Purchase Register_'+ new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
    },

    printSaleReport(){
      let saleInvoices = JSON.parse(JSON.stringify(this.normalData));
      saleInvoices = saleInvoices.filter((item => item['name']!='total'));
      saleInvoices.map((item,index)=>{
        saleInvoices[index]["firmName"] = this.getFirmName(item.firm);
        saleInvoices[index]["buyerName"] = this.buyerById(item.buyerId).name;
        saleInvoices[index]["GST_TOTAL"] = this.getGSTtotal(item);
        saleInvoices[index]["BASIC_AMOUNT"] = (item.totalAmount - saleInvoices[index]["GST_TOTAL"] || 0);
        saleInvoices[index]["IGST"] = (item.gstType == 'IGST' ? saleInvoices[index]["GST_TOTAL"] : 0)
        saleInvoices[index]["CGST"] = (item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"]/2 : 0)
        saleInvoices[index]["SGST"] = (item.gstType == 'SGST|CGST' ? saleInvoices[index]["GST_TOTAL"]/2 : 0)
        saleInvoices[index]["GST_3"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_3'] : '')
        saleInvoices[index]["GST_5"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_5'] : '')
        saleInvoices[index]["GST_12"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_12'] : '')
        saleInvoices[index]["GST_18"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_18'] : '')
        saleInvoices[index]["GST_28"] = (item.GST_Percentage_total ? item['GST_Percentage_total']['GST_28'] : '')
      })
      let totalRow = document.querySelectorAll(".totalRow .totalField")
      saleInvoices.push({
        firmName : 'Total',
        buyerName : '',
        GST_TOTAL : totalRow[2].innerText.replaceAll(",",""),
        BASIC_AMOUNT : totalRow[1].innerText.replaceAll(",",""),
        discountAmount : totalRow[4].innerText.replaceAll(",",""),
        IGST : 0,
        CGST : 0,
        SGST : 0,
        GST_3 :  totalRow[7].innerText.replaceAll(",",""),
        GST_5 :  totalRow[8].innerText.replaceAll(",",""),
        GST_12:  totalRow[9].innerText.replaceAll(",",""),
        GST_18:  totalRow[10].innerText.replaceAll(",",""),
        GST_28:  totalRow[11].innerText.replaceAll(",",""),
        totalAmount : totalRow[0].innerText.replaceAll(",",""),

      })
      let doc = convertToPDFReport({
        type:'Sale Register',
        invoiceData:saleInvoices,
        firm:this.selectedFirm ? this.getFirmName(this.selectedFirm) : null,
        fromDate : this.dateFrom ? new Date(this.dateFrom).toLocaleDateString('en-GB') : null,
        toDate :  this.dateTo ? new Date(this.dateTo).toLocaleDateString('en-GB') : null,
      });
      pdfMake.createPdf(doc).download('Sale Register_'+ new Date(this.dateFrom).toLocaleDateString('en-GB') + 'to' + new Date(this.dateTo).toLocaleDateString('en-GB'));
    },
  },
};
</script>

<style>
.flexColumn {
  flex-direction: column;
  align-items: flex-start;
}
.theme--light .white-switch {
  margin-top: 25px;
}

.theme--light .white-switch .v-label {
  color: white;
}

.white-datepicker .v-icon,
.white-datepicker .v-label,
.white-datepicker input {
  color: white !important;
}

.white-datepicker .v-input__slot:before {
  border-color: white !important;
}
.theme--light div.select-firm .v-icon {
  color: white;
}
.theme--light div.select-firm .v-label {
  color: white;
}
.theme--light div.select-firm .v-input__slot:before {
  border-color: white !important;
}
div.select-firm .v-select__selection--comma {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/SalePurchaseStatements/invoiceList.vue